<template>
  <el-dialog
    :title="$t('public.details')"
    :visible.sync="dialogFormVisible"
    width="60vw"
    height="100vh"
    top="2vh"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="close"
  >
    <el-table v-loading="listLoading" :data="tableData" border style="width: 100%">
      <el-table-column align="center" prop="itemName" :label="$t('shop.goods_name')" />
      <el-table-column align="center" prop="itemNo" :label="$t('itemNo')" />
      <el-table-column align="center" prop="itemQty" :label="$t('langs.quantity_commodity')" />
    </el-table>
    <el-pagination background :current-page="queryForm.page" :layout="layout" :page-size="queryForm.limit"
      :total="total" style="margin-top: 10px" @current-change="handleCurrentChange" @size-change="handleSizeChange" />
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">{{ $t('public.backTop') }}</el-button>
    </div>
  </el-dialog>
</template>
<script>

import {
  distributionListDetail
} from '@/api/xgcApi'
export default {
  name: 'BoxBinding',
  data() {
    return {
      dialogFormVisible: false, // 弹窗显示,隐藏
      listLoading: false, // 请求数据加载
      tableData: [],
      layout: 'total, sizes, prev, pager, next, jumper',
      total: 0,
      queryForm: {
        page: 1,
        limit: 10,
        pickingTaskId: ''
      }
    }
  },
  methods: {
    // 页面初始化方法
    showEdit(row) {
      this.queryForm.pickingTaskId = row
      this.dialogFormVisible = true
      this.getTableDataList() // 获取弹窗列表数据
    },
    // 获取弹窗列表数据
    getTableDataList() {
      this.listLoading = true
      distributionListDetail(this.queryForm).then(res => {
        this.tableData = res.page.list
        this.total = res.page.totalCount
      })
      setTimeout(() => {
        this.listLoading = false
      }, 300)
    },
    handleSizeChange(val) {
      this.queryForm.limit = val
      this.getTableDataList()
    },
    handleCurrentChange(val) {
      this.queryForm.page = val
      this.getTableDataList()
    },
    close() {
      this.dialogFormVisible = false
      this.$emit('fetch-data')
    }
  }
}
</script>
<style>
  .item_box {
    border: 1px solid #999;
    border-radius: 10px;
    padding: 16px;
    box-sizing: border-box;
    margin-bottom: 16px;
  }
  .warning-row {
    background: oldlace;
    /* 或者其他颜色 */
  }
</style>
